import type React from "react"

export interface ModalContextProps {
    title?: string
    content?: React.ReactNode
    onOk?: (() => void) | (() => Promise<void>)
    onCancel?: () => void
}

export interface ModalProps extends ModalContextProps {
    open: boolean
    close: () => void
}

export enum ModalsKeys {
    Confirm = "Confirm",
    None = "None",
    WelcomeMessage = "WelcomeMessage",
}
